export default __webpack_public_path__ + "static/img_interviewee_dwjung-7e6987f7595620fd60cba4706478c383.png";